import React from 'react';

const ApproachContext = React.createContext('formal');
export default ApproachContext;
